import React from "react";
import ReactECharts from "echarts-for-react";

const QualityDimesionGraph = (props) => {
  const pointerColour =
    props.value && props.value > 90
      ? "#009E60"
      : props.value && props.value > 80
      ? "#FFBF00"
      : "#FF2400";

  const option = {
    color: pointerColour, //"#0000A3","#73c0de ,#5470c6"
    tooltip: {
      trigger: "item",
      formatter(param) {
        // correct the percentage
        return `${props.name} : ${param.value}%`;
      },
    },
    series: [
      {
        type: "gauge",
        center: ["50%", "60%"],
        startAngle: 180,
        endAngle: 0,
        itemStyle: {
          borderWidth: 1,
          borderColor: "#464646",
        },
        pointer: {
          itemStyle: {
            color: pointerColour,
          },
        },
        progress: {
          show: true,
          width: 30,
        },
        pointer: {
          show: true,
        },
        axisLine: {
          lineStyle: {
            width: 30,
          },
        },
        axisTick: {
          distance: -40,
          length: 6,
          width: 10,
          show: true,
        },
        splitLine: {
          distance: -39,
          length: 10,
          lineStyle: { type: "solid", width: 3 },
        },
        axisLabel: {
          distance: -4,
          color: "#000",
          fontSize: 14,
        },
        anchor: {
          show: false,
        },
        title: {
          fontSize: 14,
        },
        detail: {
          valueAnimation: true,
          fontSize: 14,
          formatter: `${props.name} : {value}%`,
          color: "#464646",
        },
        data: [
          {
            value: props.value,
          },
        ],
      },
    ],
  };

  return (
    <React.Fragment>
      <ReactECharts
        className="quality_dimesion_graph"
        option={option}
        showLoading={props.loading}
      />
    </React.Fragment>
  );
};

export default QualityDimesionGraph;
